import { render, staticRenderFns } from "./polisaTable.vue?vue&type=template&id=73411b08&scoped=true"
import script from "./polisaTable.vue?vue&type=script&lang=js"
export * from "./polisaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73411b08",
  null
  
)

export default component.exports